export class EquipmentGraphicsFilter {
    
    public EquipmentGraphicsIDs?: number[];
    public IncludeInactive?: boolean;
}

export default EquipmentGraphicsFilter;